export default "<p>find-trainings works!</p>\r\n"